import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 768px) {
    overflow-x: visible;
  }
`;

export const Table = styled.table`
  text-align: left;
  width: 100%;
  table-layout: fixed;

  th,
  td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tbody {
    background-color: var(--surface);
  }

  tbody tr:nth-child(even) {
    background-color: var(--surface-elevated);
  }

  @media (max-width: 768px) {
    table-layout: auto;

    colgroup,
    thead {
      display: none;
    }

    tbody,
    tr,
    td {
      display: block;
      width: 100%;
    }

    tr {
      padding: 12px;
      border-bottom: 1px solid var(--border);
    }

    td {
      overflow: visible;
      text-overflow: clip;
      white-space: normal;
      padding: 4px 0;
    }

    td:first-child {
      font-weight: 600;
      font-size: 1.05em;
    }
  }
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;
